import React from 'react';
import ArticleAudioButtonPlay from '@src/icons/ArticleAudioButtonPlay';
import ArticleAudioButtonPause from '@src/icons/ArticleAudioButtonPause';

interface Props {
  isPlaying: boolean;
}

export default function ArticleAudioButton({ isPlaying }: Props) {
  return (
    <div style={styles.container}>
      {isPlaying && <ArticleAudioButtonPause />}
      {!isPlaying && <ArticleAudioButtonPlay />}
    </div>
  );
}

const styles = {
  container: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    border: '2px solid #C5E3C1',
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 20
  }
};
